// extracted by mini-css-extract-plugin
module.exports = {"list":"list--2wKM_","icon":"icon--gfDm3","default":"default--3i5Az","primary":"primary--Xhmvp","danger":"danger--1nVSr","warning":"warning--REZyD","success":"success--w4XzE"};